import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ParticipantRole} from '@npck/af-frontend-api';
import dayjs from 'dayjs';
import {DateRangeFormValue} from '../../../../../../../components/date-range-picker-field/date-range-picker-field.component';
import {getPostfixByDateRange} from '../../classification-table-header/classification-table-header.component';
import {CellViewModel, ClassificationColumn, ClassificationRow} from '../../classification-table.component';

@Component({
    templateUrl: './classification-table-cell-details-dialog.component.html',
    styleUrl: './classification-table-cell-details-dialog.component.scss',
    standalone: false,
})
export class ClassificationTableCellDetailsDialogComponent {
    contentLabelPostfix: string;
    filteredCellData: CellViewModel[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: ClassificationTableCellDetailsDialogData,
        public dialogRef: MatDialogRef<ClassificationTableCellDetailsDialogComponent>,
    ) {
        const startDate = dayjs(dialogData.selectedDateRange.dateFrom);
        const endDate = dayjs(dialogData.selectedDateRange.dateTo);
        this.contentLabelPostfix = getPostfixByDateRange(startDate, endDate);
        this.filteredCellData = this.dialogData.cellData;
        if (this.dialogData.row === 'subjectCountry') {
            this.filteredCellData = this.dialogData.cellData.filter(value => !!value.count && !!value.value);
        }
        if (!this.filteredCellData.length) {
            this.filteredCellData = this.dialogData.cellData.slice(0, Math.min(this.dialogData.cellData.length - 1, 10));
        }
        if (['forecastFuture', 'forecastPast'].includes(this.dialogData.column)) {
            this.contentLabelPostfix = this.dialogData.column;
        }
    }

}

export interface ClassificationTableCellDetailsDialogData {
    row: ClassificationRow;
    column: ClassificationColumn;
    translationPostfix: string;
    selectedDateRange: DateRangeFormValue;
    cellData: CellViewModel[];
    participantRole: ParticipantRole;
}
